import "./notificationAfterReload.js";
import { HINWEISE } from "./hinweise.js";
import { sleep } from "../../assets/js/utils/timeout.js";

export default class MerkzettelHinweis extends HTMLElement {
    static tag = "merkzettel-hinweis";
    static {
        if (!customElements.get(MerkzettelHinweis.tag)) {
            customElements.define(MerkzettelHinweis.tag, MerkzettelHinweis);
        }
    }

    constructor() {
        super();
        this.events = ["click"];
        this.addListener();
    }

    disconnectedCallback() {
        this.removeListener();
    }

    addListener() {
        for (const event of this.events) {
            window.addEventListener(event, this);
        }
    }

    removeListener() {
        for (const event of this.events) {
            window.removeEventListener(event, this);
        }
    }

    handleEvent(event) {
        this[`handle${event.type}`](event);
    }

    async handleclick(event) {
        const { target } = event;
        // MerkzettelHinweis wird geschlossen
        // 1. wenn das Schließen X geklickt wird oder
        // 2. wenn aus dem Hinweis heraus ein weiteres Popover/Dialog geöffnet wird
        if (target.getAttribute("cta") === "close" || target.getAttribute("command") === "show-modal") {
            await sleep(100);
            this.close();
            this.remove();
        }
    }

    render(container, messageid) {
        const hinweisDaten = HINWEISE[messageid];
        if (hinweisDaten === undefined) {
            console.info(`MerkzettelHinweis: unbekannte messageid "${messageid}"`);
            return;
        }
        const template = document.querySelector('template[id="merkzettel-hinweis"]');
        const clone = template.content.cloneNode(true);
        const {typ} = hinweisDaten
        this.hinweis = clone.querySelector(`[data-typ="${typ}"]`);
        this.hinweis.id = messageid;
        this.hinweis.querySelector("[data-titel]").textContent = hinweisDaten.titel;
        this.appendChild(this.hinweis);
        container.appendChild(this);
    }

    open() {
        // showPopover() hebt den Hinweis in den Top Layer (entkommt Stacking Contexts /
        // overflow und liegt über Modal-Dialogen). Feature-detected: ältere Browser und
        // jsdom fallen auf das reine position:fixed-Verhalten zurück.
        if (typeof this.hinweis.showPopover === "function" && this.hinweis.isConnected) {
            this.hinweis.showPopover();
        }
        this.hinweis.setAttribute("animate", "");
    }

    close() {
        this.hinweis.removeAttribute("animate");
        if (typeof this.hinweis.hidePopover === "function" && this.hinweis.matches(":popover-open")) {
            this.hinweis.hidePopover();
        }
    }

    remove() {
        this.parentNode.removeChild(this);
    }
}
